export default __webpack_public_path__ + "static/media/badge-check.8c68d1a8.svg";